import { queryClient, useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { addEventDistributionList } from '../../services';
import { getEventParticipantsInfiniteQueryKey, getNodeEventDetailQueryKey } from '../keys';

type AddEventDistributionListVariables = {
  distributionList: Array<{ communityId: string; communityName: string }>;
  eventId: string;
};

const defaultErrorHandler = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. Invitations couldn’t been sent.');
};

export const useAddEventDistributionList = () =>
  useMutation<undefined, AddEventDistributionListVariables>({
    defaultMutateOnError: defaultErrorHandler,
    async mutationFn({ distributionList, eventId }) {
      const response = await addEventDistributionList({
        body: distributionList,
        routeParams: { eventId },
      });

      return response.data;
    },
    async onSuccess(_, { eventId }) {
      await queryClient.invalidateQueries({ queryKey: getEventParticipantsInfiniteQueryKey({ filter: { eventId } }) });
      await queryClient.invalidateQueries({ queryKey: getNodeEventDetailQueryKey({ eventId }) });
    },
  });
